(ns core.http
  (:require [clojure.string :as str]))

(def request-id-header "x-request-id")


(defn get-request-id [{:keys [headers]}]
  (get headers request-id-header))


(defn command-name->path
  "Returns the path (starting from root /) to call on the server for a given command name.
   If you need the full URL on server side, see core.util.http/command->url"
  ([command-name]
   (command-name->path "/api/command/" command-name))
  ([prefix command-name]
   (if (keyword? command-name)
     (str prefix
          (as-> command-name n (namespace n) (str/split n #"\.") (str/join "/" n))
          "/"
          (-> command-name name))
     (str prefix command-name))))
